<template>
  <CommonPopup ref="refCommonPopup">
    <div class="tips-popup">
      <div class="tips-popup-content">
        <div class="tips-title">{{ config.title }}</div>
        <div class="tips-column">
          {{ config.text }}
        </div>
      </div>
      <div class="tips-popup-btns">
        <div
          v-if="config.showCancelBtn"
          class="tips-popup-btn btn-default"
          @click="handleCancel"
        >
          {{ config.cancelBtnText }}
        </div>
        <div
          class="tips-popup-btn btn-primary"
          @click="handleConfirm"
        >
          {{ config.confirmBtnText }}
        </div>
      </div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';

class PopupConfig {
  showCancelBtn = false;
  cancelBtnText = '返回';
  confirmBtnText = '确定';
  text = '';
  title = '温馨提示'
}

export default {
  name: 'WaitPayPopup',
  components: {
    CommonPopup
  },
  data() {
    return {
      config: new PopupConfig()
    };
  },
  methods: {
    openPopup(config = new PopupConfig()) {
      this.config = {
        ...new PopupConfig(),
        ...config
      };
      this.$refs.refCommonPopup.openPopup();
      this.$emit('open');
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm', this.config.confirm);
      this.closePopup();
    },
    handleCancel() {
      this.$emit('cancel');
      this.closePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.tips-popup {
  background: #ffffff;
  border-radius: 20px;
  width: 600px;
  box-sizing: border-box;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .tips-popup-content {
    width: 100%;

    .tips-title {
      font-size: 32px;
      color: #383838;
      text-align: center;
      font-weight: bold;
      line-height: 45px;
      margin-bottom: 48px;
    }
    .tips-column {
      display: flex;
      align-items: center;
      font-size: 32px;
      color: #787878;
      font-weight: 400;
      line-height: 45px;
      margin-bottom: 72px;
    }
  }
  .tips-popup-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .tips-popup-btn {
      flex: 1;
      height: 90px;
      border-radius: 20px;
      font-size: 32px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;

      &.btn-default {
        border: 1px solid rgba(200, 200, 200, 1);
        background: #ffffff;
        color: #383838;
      }
      &.btn-primary {
        background: #fe7256;
        color: #ffffff;
      }
      &:nth-child(even) {
        margin-left: 32px;
      }
    }
  }
  .text-orange {
    color: #ff722c !important;
  }
}
</style>
